export const navigatorPath = {
    admin : [
                {text:'HOME',url:'/admin'},
                {text:'대시보드',url:'/admin'}
            ],
    items : [
                {text:'자산관리',url:'/admin/items'},
                {text:'자산목록',url:'/admin/items'},
            ],
    hist : [
                {text:'자산관리',url:'/admin/items'},
                {text:'이력',url:'/admin/items/hist'},
            ],
    rel : [
                {text:'자산관리',url:'/admin/items'},
                {text:'연계자산',url:'/admin/items/rel'},
            ],
    inspects : [
                {text:'자산관리',url:'/admin/items'},
                {text:'자산조사',url:'/admin/inspects'},
            ],
    ispDetail : [
                {text:'자산관리',url:'/admin/items'},
                {text:'자산조사',url:'/admin/inspects'},
                {text:'자산조사 상세',url:''},
            ],
    inout : [
                {text:'반출입',url:'/admin/inout'},
                {text:'반출입관리',url:'/admin/inout'},
            ],
    inoutDetail : [
                {text:'반출입',url:'/admin/inout'},
                {text:'반출입관리',url:'/admin/inout'},
                {text:'반출입 상세',url:'/'},
            ],
    inoutHist : [
                {text:'반출입',url:'/admin/inout'},
                {text:'이력',url:'/admin/inoutHist'},
            ],
    mngnt : [
                {text:'설정',url:'/admin/setting/password'},
                // {text:'Management',url:'/admin'},
            ],
}